import { Component, OnDestroy, ViewChild } from '@angular/core';
import { Tenant } from '@app/Models/tenant';
import { PermissionService } from '@app/Services';
import { Subject, Observable } from 'rxjs';
import { CloneService } from '../Services';
import { Permissions } from '@app/Models/Permissions';
import { MessageJobSeverity } from '@app/Enums';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatRadioGroup } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { RadioButtonCardComponent } from '../../../../Common/controls/radio-button-card/radio-button-card.component';
import { JobLiveViewComponent } from '../../../../Jobs/job.liveview.component';
import { CloneExportImportComponent } from './clone-export-import/clone-export-import.component';
import { CloneExportOnlyComponent } from './clone-export-only/clone-export-only.component';
import { CloneImportOnlyComponent } from './clone-import-only/clone-import-only.component';

@Component({
    selector: 'app-clone-tenant',
    templateUrl: './clone-tenant.component.html',
    styleUrls: ['./clone-tenant.component.scss'],
    imports: [MatIcon, MatRadioGroup, FormsModule, RadioButtonCardComponent, JobLiveViewComponent, CloneExportImportComponent, CloneExportOnlyComponent, CloneImportOnlyComponent, AsyncPipe]
})
export class CloneTenantComponent implements OnDestroy {
  cloneInProgress$: Observable<boolean>;
  hasCloneStarted$: Observable<boolean>;
  cloneJobId$: Observable<string | null>;

  cloneFromTenant: string;
  cloneToTenant: string;
  cloneToEnvironmentId: number;
  isCloneInProgress = false;
  isJobCompleted = false;
  jobId: string;
  clonedTenant: Tenant = new Tenant();

  cloneOption = 'ExportImport';
  cloneOptions = [
    {
      value: 'ExportImport',
      label: 'Export & Import',
      shortDescription: 'Clone on the same environment (Recommended)',
      info: 'This job does a complete process of exporting and importing the configuration & data from the selected tenant' +
        'and clones them into a new tenant. You are able to clone only on the same environment.',
      descriptionIcon: 'info',
      icon: 'swap_vert'
    },
    {
      value: 'Export',
      label: 'Export Only',
      shortDescription: 'Clone across environments',
      info: 'This job only exports the selected configuration & data. ' +
        'It will give you an unique code to pass it to CloudOps team in order to be able to clone ' +
        'the configuration & data on a new tenant from another environment.',
      descriptionIcon: 'warning',
      icon: 'arrow_upward'
    },
    {
      value: 'Import',
      label: 'Import Only',
      shortDescription: 'Clone across environments',
      info: 'This job only imports the selected configuration & data. ' +
        'It will require an unique code from CloudOps team in order to be able to import ' +
        'the configuration & data on a new tenant.',
      descriptionIcon: 'warning',
      icon: 'arrow_downward'
    },
  ];

  private isDestroyed$ = new Subject<void>();

  public constructor(
    private cloneService: CloneService,
    private permissionService: PermissionService
  ) {
    this.cloneInProgress$ = this.cloneService.cloneInProgress$;
    this.hasCloneStarted$ = this.cloneService.hasCloneStarted();
    this.cloneJobId$ = this.cloneService.cloneJobId$;
  }

  ngOnDestroy(): void {
    this.isDestroyed$.next();
    this.cloneService.reset();
  }

  getCloneSelectedOptionName(): string {
    return this.cloneOptions.find((option) => option.value === this.cloneOption)?.label;
  }

  hasPartialClonePermission(): boolean {
    return this.permissionService.hasPermission(Permissions.partialCopyConfig);
  }

  jobComplete(event: MessageJobSeverity): void {
    if (event === MessageJobSeverity.CloneSuccess || event === MessageJobSeverity.CloneExportOnlySuccess) {
      this.cloneService.cloneInProgress$.next(false);
      this.cloneService.cloneFinalised$.next(true);
    }
  }
}
